import { useAtomValue } from 'jotai';

import { RecordingNotice, RecordingNoticeProps } from './RecordingNotice';
import { otherPatientConsentedInSessionAtom } from './state';

export function RecordingNoticeWrapper({ ...rest }: Omit<RecordingNoticeProps, 'otherPatientConsentedInSession'>) {
  const otherPatientConsentedInSession = useAtomValue(otherPatientConsentedInSessionAtom);
  return <RecordingNotice {...rest} otherPatientConsentedInSession={otherPatientConsentedInSession} />;
}
